import { LitElement, html, css } from 'lit'
import { navigate } from '../router.js'

class PageNotFound extends LitElement {
  static properties = { params: { type: Array } }

  static styles = css`
    .wrap { text-align: center; padding: 4rem 1rem; }
    h1 { color: var(--bx-brand); font-size: 3rem; margin: 0; }
    p { color: var(--bx-muted); }
    button { margin-top: 1rem; padding: 0.5rem 1rem; border: none; border-radius: var(--bx-radius);
             background: var(--bx-accent); color: var(--bx-accent-ink); font-weight: 600; cursor: pointer; }
  `

  render() {
    return html`
      <div class="wrap">
        <h1>404</h1>
        <p>That page doesn't exist.</p>
        <button @click=${() => navigate('/')}>Go home</button>
      </div>
    `
  }
}

customElements.define('page-not-found', PageNotFound)
